/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PatchedDeckListingsRequest {
  first_name?: string | null;
  last_name?: string | null;
  email?: string;
  phone?: string;
  company_name?: string;
  company_description?: string;
  fundraising_goal?: string;
  attachment?: Blob | null;
  handled?: boolean;
}
